import React from 'react'

import genId from '../utils/gen_id'
import get from '../utils/get'
import {ObjectContext} from './object-store'
import {useFocusBlurSaveField} from './object-store'
import './wrktitle-editor.scss'


export default function WrktitleEditor({wrktitle, editMode, selected, onToggleSelect, ...props}) {
    const idRef = React.useRef(genId())
    return <ObjectContext model="wrktitle" id={get(wrktitle, 'id') || idRef.current}>
        <Wrktitle_ wrktitle={wrktitle} editMode={editMode} selected={selected} onToggleSelect={onToggleSelect} {...props} />
    </ObjectContext>
}

function Wrktitle_({wrktitle, day, editMode, selected, onToggleSelect}) {
    const titleProps = useFocusBlurSaveField('title', {day})

    return <div
        className="wrktitle-editor__wrap"
        onClick={editMode && wrktitle ? () => onToggleSelect(wrktitle.id) : undefined}
    >
        <input
            {...titleProps}
            className="wrktitle-editor"
        />
        {editMode && wrktitle &&
            <input type="checkbox" checked={!!selected} readOnly className="wrktitle-editor__checkbox" />
        }
    </div>
}
